import v from "./design-system.es58.js";
import { resolveComponent as s, openBlock as i, createBlock as d, normalizeClass as B, withCtx as a, createElementVNode as t, createElementBlock as p, createVNode as l, createCommentVNode as _, createTextVNode as n, toDisplayString as b } from "vue";
/* empty css                    */
/* empty css                    */
import g from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
import C from "./design-system.es108.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import k from "./design-system.es47.js";
/* empty css                    */
const L = {
  name: "DsErrorBanner",
  components: {
    Collapsible: k,
    Icon: v,
    TextButton: C
  },
  props: {
    isOpen: Boolean,
    position: {
      type: String,
      default: "top",
      validator: (r) => ["top", "bottom"].includes(r)
    },
    message: String,
    showIcon: Boolean,
    critical: Boolean,
    actionLabel: String,
    closeLabel: String
  },
  emits: [
    "action",
    "close"
  ]
}, x = { class: "error-banner-container" }, I = { class: "error-banner" }, T = { class: "error-banner-message" }, y = {
  key: 0,
  class: "error-banner-icon critical"
}, S = {
  key: 1,
  class: "error-banner-icon"
}, E = ["innerHTML"], N = { class: "error-banner-actions" };
function V(r, o, e, w, D, H) {
  const c = s("Icon"), m = s("TextButton"), f = s("Collapsible");
  return i(), d(f, {
    "is-open": e.isOpen,
    class: B({ bottom: e.position === "bottom" })
  }, {
    default: a(() => [
      t("div", x, [
        t("div", I, [
          t("div", T, [
            e.critical ? (i(), p("div", y, [
              l(c, { name: "alert-triangle" })
            ])) : e.showIcon ? (i(), p("div", S, [
              l(c, { name: "alert-circle" })
            ])) : _("", !0),
            o[2] || (o[2] = n()),
            t("span", { innerHTML: e.message }, null, 8, E)
          ]),
          o[4] || (o[4] = n()),
          t("div", N, [
            l(m, {
              onClick: o[0] || (o[0] = (u) => r.$emit("close"))
            }, {
              default: a(() => [
                n(b(e.closeLabel), 1)
              ]),
              _: 1
            }),
            o[3] || (o[3] = n()),
            e.actionLabel ? (i(), d(m, {
              key: 0,
              onClick: o[1] || (o[1] = (u) => r.$emit("action"))
            }, {
              default: a(() => [
                n(b(e.actionLabel), 1)
              ]),
              _: 1
            })) : _("", !0)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open", "class"]);
}
const R = /* @__PURE__ */ g(L, [["render", V], ["__scopeId", "data-v-d242fa1b"]]);
export {
  R as default
};
//# sourceMappingURL=design-system.es9.js.map
